<template>
  <div class="contenido">
    <Loading :active="isLoading" :can-cancel="true" :is-full-page="fullPage" />

    <Titulo titulo="CONSULTA DE SALDOS" />

    <b-container class="mt-4">
      <b-row class="mb-1">
        <!-- el formulario de busqueda (para administrador) -->
        <b-col cols="12" xs="4" sm="4" md="4" v-show="tipoUsuario == 'A'">
          <b-form id="formConsSaldo" @submit.prevent="consultarSaldoForm">
            <b-input-group-append>
              <b-form-input
                name="num_contrato"
                type="text"
                placeholder="Contrato"
                class="text-uppercase"
                required
              ></b-form-input>
              <b-button type="submit" variant="primary">Buscar</b-button>
            </b-input-group-append>
          </b-form>
        </b-col>

        <!-- el selector de contratos -->
        <b-col cols="12" xs="4" sm="4" md="4" v-show="contratos.length > 1">
          <b-button-group>
            <b-button variant="primary">Seleccione el </b-button>
            <b-dropdown variant="primary" right text="Contrato">
              <b-dropdown-item
                v-for="cont in contratos"
                :key="cont.num_contrato"
                @click="consultarSaldo(cont.num_contrato)"
                >{{ cont.num_contrato }} - {{ cont.domicilio }}</b-dropdown-item
              >
            </b-dropdown>
          </b-button-group>
        </b-col>

        <b-col cols="2"></b-col>

        <!-- el boton de imprimir -->
        <b-col cols="12" xs="2" sm="2" md="2"> </b-col>

        <!-- fecha de actualizacion -->
        <b-col cols="12" xs="4" sm="5" md="4">
          Fecha de actualización: {{ parametros.fecha_sincroniza }}
        </b-col>
      </b-row>

      <b-card class="mb-1">
        <b-row>
          <b-col cols="12" md="6">
            <b-row>
              <b-col cols="12" md="3"><strong>Propietario:</strong></b-col>
              <b-col cols="12" md="9">{{ contrato.PROPIETARIO }}</b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="3"><strong>Domicilio:</strong></b-col>
              <b-col cols="12" md="9">{{ contrato.DOMICILIO }}</b-col>
            </b-row>
          </b-col>
          <b-col cols="12" md="6">
            <b-row>
              <b-col cols="12" md="3"><strong>Contrato:</strong></b-col>
              <b-col cols="12" md="9">{{ contrato.NUM_CONTRATO }}</b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="3"><strong>Referencia:</strong></b-col>
              <b-col cols="12" md="9">{{ contrato.REFERENCIA }}</b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>

      <!-- los detalles de saldo -->
      <b-card class="gridDatos m-0 mb-1">
        <b-table
          sticky-header="true"
          small
          striped
          select-mode="range"
          selectable
          ref="tablaAdeudo"
          :items="detalle_saldos"
          :fields="fields"
          @row-selected="onRowSelected"
        >
          <template #cell(cuotas)="data">
            <span>
              {{ data.item.cuotas | moneda }}
            </span>
          </template>
          <template #cell(recargos)="data">
            <span>
              {{ data.item.recargos | moneda }}
            </span>
          </template>
          <template #cell(total)="data">
            <span>
              {{ (Number(data.item.cuotas) + Number(data.item.recargos)) | moneda }}
            </span>
          </template>
        </b-table>
      </b-card>

      <!-- los totales -->
      <b-row class="mb-3">
        <b-col cols="12" md="8">
          <div class="pt-2">
            <b-form-textarea
              :value="parametros.msj_conssaldo"
              size="sm"
              rows="5"
              max-rows="6"
              disabled
            ></b-form-textarea>
          </div>
        </b-col>
        <b-col cols="12" md="4">
          <b-row class="text-right">
            <b-col cols="12" xs="8" sm="8" md="8"
              ><span><strong>Cuotas Mantenimiento</strong></span></b-col
            >
            <b-col cols="12" xs="4" sm="4" md="4"
              ><span>{{ totalCuotas | moneda }}</span></b-col
            >
          </b-row>
          <b-row class="text-right">
            <b-col cols="12" xs="8" sm="8" md="8"
              ><span><strong>Recargos</strong></span></b-col
            >
            <b-col cols="12" xs="4" sm="4" md="4"
              ><span>{{ totalRecargos | moneda }}</span></b-col
            >
          </b-row>
          <b-row class="text-right">
            <b-col cols="12" xs="8" sm="8" md="8"
              ><span><strong>Gastos</strong></span></b-col
            >
            <b-col cols="12" xs="4" sm="4" md="4"
              ><span>{{ totalGastos | moneda }}</span></b-col
            >
          </b-row>
          <b-row class="text-right">
            <b-col cols="12" xs="8" sm="8" md="8"
              ><span><strong>Otros cargos</strong></span></b-col
            >
            <b-col cols="12" xs="4" sm="4" md="4"
              ><span>{{ otrosCargos | moneda }}</span></b-col
            >
          </b-row>
          <b-row class="text-right">
            <b-col cols="12" xs="8" sm="8" md="8"
              ><span><strong>Total</strong></span></b-col
            >
            <b-col cols="12" xs="4" sm="4" md="4"
              ><span
                ><strong>{{ granTotal | moneda }}</strong></span
              ></b-col
            >
          </b-row>
        </b-col>
      </b-row>

      <b-row class="d-flex justify-content-end mb-3 mr-0">
        <!-- el boton de imprimir -->
        <b-button
          variant="primary mr-1"
          @click="imprimir"
          :disabled="Object.keys(this.contrato).length === 0"
        >
          <b-icon-printer></b-icon-printer> Estado de cuenta
        </b-button>
        <!-- el boton de pagar -->
        <b-button
          variant="primary"
          @click="pagar"
          :disabled="Object.keys(this.contrato).length === 0"
          v-if="paypal.clientId != '' || mercadoPago.key != ''"
        >
          <b-icon-credit-card></b-icon-credit-card> Pagar
        </b-button>
      </b-row>
    </b-container>
  </div>

</template>

<script>
import Titulo from "@/components/Titulo.vue";
import Swal from "sweetalert2";
const axios = require("axios");
import { mapState } from "vuex";
var numeral = require("numeral");
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "ConsultaSaldo",
  filters: {
    numero: function (value) {
      return numeral(value).format("0,0.00");
    },
    moneda: function (value) {
      return numeral(value).format("$0,0.00");
    },
  },
  components: {
    Titulo,
    Loading,
  },
  data() {
    return {
      //
      contratos: [],
      contrato: {},
      parametros: {},
      detalle_saldos: [],
      selected: [],
      fields: [
        "periodo",
        "concepto",
        { key: "tipo_cuota", label: "Tipo de cuota" },
        "cuotas",
        "recargos",
        "total",
      ],
      //
      isLoading: true,
      fullPage: true,
    };
  },
  created() {
    if (localStorage.getItem("contrato")) {
      this.contrato = JSON.parse(localStorage.getItem("contrato"));
    }

    if (this.tipoUsuario == "C") {
      if (this.contrato.hasOwnProperty("ID_CONTRATO")) {
        this.consultarSaldo(this.contrato.NUM_CONTRATO);
      } else {
        this.traerContratos();
      }
    } else {
      if (this.contrato.hasOwnProperty("ID_CONTRATO")) {
        this.consultarSaldo(this.contrato.NUM_CONTRATO);
      } else {
        this.isLoading = false;
      }
    }

    this.traerParametros();
  },
  mounted() {
    
  },
  methods: {
    traerParametros() {
      var formData = new FormData();
      formData.append("accion", "mostrarDatos");
      formData.append("tabla", "parametros");
      formData.append("limite", 1);

      axios.post(`${this.url}/ajax/ajax.generico.php`, formData).then((res) => {
        this.parametros = res.data;
      });
    },
    traerContratos() {
      /* ===========================
       * se trae los contratos que ligan con el usuario logueado
       * se usa con los usuarios tipo colono para mostrar en automatico
       * su saldo en caso de ser un solo contrato
       * ========================= */
      var formData = new FormData();
      formData.append("accion", "traerContratos");
      formData.append("idUsuario", this.idUsuario);

      axios.post(`${this.url}/ajax/ajax.usuarios.php`, formData).then((res) => {
        if (res.data) {
          this.contratos = res.data;

          if (this.contratos.length == 0) {
            Swal.fire({
              title: "Atención",
              text: "No se encontrarón contratos ligados a su usuario, por favor comuniquese con la asociación de colonos",
              icon: "error",
              confirmButtonText: "Aceptar",
              confirmButtonColor: "#3085d6",
            });
          }

          if (this.contratos.length == 1) {
            this.consultarSaldo(this.contratos[0].num_contrato);
          } else {
            this.isLoading = false;
          }
        } else {
          Swal.fire({
            title: "Error",
            text: "No se encontrarón contratos ligados al usuario...",
            icon: "error",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
          });
        }
      });
    },
    procesaSaldo(formData) {
      this.isLoading = true;
      this.contrato = {};
      this.detalle_saldos = [];

      axios
        .post(`${this.url}/ajax/ajax.contratos.php`, formData)
        .then((res) => {
          this.isLoading = false;

          if (res.data) {
            this.contrato = res.data;
            this.detalle_saldos = res.data.saldos;
          } else {
            Swal.fire({
              title: "Atención",
              text: "Contrato no localizado",
              icon: "warning",
              confirmButtonText: "Aceptar",
              confirmButtonColor: "#3085d6",
            });
          }
        });
    },
    consultarSaldoForm() {
      const form = document.getElementById("formConsSaldo");
      var formData = new FormData(form);
      formData.append("accion", "conssaldo");

      this.procesaSaldo(formData);
    },
    consultarSaldo(numContrato = 0) {
      var formData = new FormData();
      formData.append("num_contrato", numContrato);
      formData.append("accion", "conssaldo");

      this.procesaSaldo(formData);
    },
    imprimir() {
      window.open(
        `${process.env.VUE_APP_PRESTA_API_URL}/reportes/repEdoCta.php?id=${this.contrato.ID_CONTRATO}`,
        "window"
      );
    },
    pagar() {
      // ponemos en el local storage lo que vamos a necesitar
      localStorage.setItem("parametros", JSON.stringify(this.parametros));
      localStorage.setItem("contrato", JSON.stringify(this.contrato));

      if (this.selected.length > 0) {
        localStorage.setItem("detalle_saldos", JSON.stringify(this.selected));
      } else {
        localStorage.setItem("detalle_saldos", JSON.stringify(this.detalle_saldos));
      }

      this.$router.push("pagos");
    },
    onRowSelected(items) {
      this.selected = items;

      if (this.selected.length == 1) {
        if (this.selected[0].periodo != this.detalle_saldos[0].periodo) {
          this.$refs.tablaAdeudo.clearSelected();
        }
      }
    },
  },
  computed: {
    url() {
      if (["localhost", "127.0.0.1", ""].includes(window.location.hostname)) {
        return this.urlSandbox;
      } else {
        return this.urlProd;
      }
    },
    ...mapState(["urlProd", "urlSandbox", 'token', 'idUsuario', 'tipoUsuario', 'paypal', 'mercadoPago']),
    totalCuotas() {
      var total = 0;

      if (this.selected.length > 0) {
        this.selected.forEach((element) => {
          if (element.periodo != "") {
            total += Number(element.cuotas);
          }
        });
      } else {
        this.detalle_saldos.forEach((element) => {
          if (element.periodo != "") {
            total += Number(element.cuotas);
          }
        });
      }
      return total.toFixed(2);
    },
    totalRecargos() {
      var total = 0;
      this.detalle_saldos.forEach((element) => {
        total += Number(element.recargos);
      });
      return total.toFixed(2);
    },
    totalGastos() {
      return 0.0;
    },
    otrosCargos() {
      var total = 0;
      this.detalle_saldos.forEach((element) => {
        if (element.periodo == "") {
          total += Number(element.cuotas);
        }
      });
      return total.toFixed(2);
    },
    granTotal() {
      var cuotas = 0;
      var recargos = 0;
      var otros_cargos = 0;
      var total = 0;

      if (this.selected.length > 0) {
        this.selected.forEach((element) => {
          if (element.periodo == "") {
            cuotas += Number(element.cuotas);
          } else {
            otros_cargos += Number(element.cuotas);
          }
          recargos += Number(element.recargos);
        });
      } else {
        this.detalle_saldos.forEach((element) => {
          if (element.periodo == "") {
            cuotas += Number(element.cuotas);
          } else {
            otros_cargos += Number(element.cuotas);
          }
          recargos += Number(element.recargos);
        });
      }

      total = cuotas + recargos + otros_cargos;
      return total.toFixed(2);
    },
  },
};
</script>

<style scoped>
    .contenido {
        min-height: 500px;
    }

    .gridDatos {
        overflow-y: scroll;
        height: 350px;
    }
</style>